import { useMemo } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getIndexRoute } from "../../helpers/global";
import { PROTECTED_ROUTES, PUBLIC_ROUTES } from "../../constants/routes";
import { APP_PATHS } from "../../constants/paths";
import Login from "../Login/Login";

const Router = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  const appRoutes = useMemo(
    () => [...PUBLIC_ROUTES, ...(isAuthenticated ? PROTECTED_ROUTES : [])],
    [isAuthenticated]
  );

  const getIndexSubRoute = (subRoutes) => {
    const indexRoute = getIndexRoute(subRoutes);
    if (indexRoute) {
      return <Route index element={<indexRoute.component />} />;
    } else {
      return null;
    }
  };

  return (
    <Routes>
      {appRoutes.map((route, index) =>
        route.subRoutes ? (
          <Route key={index} path={route.path} element={<route.component />}>
            {getIndexSubRoute(route.subRoutes)}
            {route.subRoutes.map((subRoute, index) => (
              <Route
                key={index}
                path={subRoute.path}
                element={<subRoute.component />}
              />
            ))}
          </Route>
        ) : (
          <Route key={index} path={route.path} element={<route.component />} />
        )
      )}

      <Route
        path={APP_PATHS.LOGIN.url}
        element={
          isAuthenticated ? (
            <Navigate to={APP_PATHS.HOME.url} replace />
          ) : (
            <Login />
          )
        }
      />
      <Route
        path={APP_PATHS.NOT_FOUND}
        element={
          <Navigate
            to={isAuthenticated ? APP_PATHS.HOME.url : APP_PATHS.LANDING.url}
            replace
          />
        }
      />
    </Routes>
  );
};

export default Router;
